import React from 'react';
import { matchPath, withRouter } from 'react-router';

var renderer = function renderer(_ref) {
  var breadcrumb = _ref.breadcrumb,
      match = _ref.match;

  if (typeof breadcrumb === 'function') {
    return breadcrumb({
      match: match
    });
  }

  return breadcrumb;
};

export var getUrlStructure = function getUrlStructure(_ref2) {
  var routes = _ref2.routes,
      pathname = _ref2.pathname;
  var matches = [];
  pathname.replace(/\/$/, '').split('/').reduce(function (previous, current) {
    var pathSection = "".concat(previous, "/").concat(current);
    var breadcrumbMatch;
    routes.some(function (_ref3) {
      var breadcrumb = _ref3.breadcrumb,
          path = _ref3.path,
          title = _ref3.title;
      var match = matchPath(pathSection, {
        exact: true,
        path: path
      });

      if (match) {
        breadcrumbMatch = {
          breadcrumb: renderer({
            breadcrumb: breadcrumb,
            match: match
          }),
          path: path,
          match: match,
          title: title
        };
        return true;
      }

      return false;
    });

    if (breadcrumbMatch) {
      matches.push(breadcrumbMatch);
    } else {
      var title = document.title;
      breadcrumbMatch = {
        breadcrumb: title,
        path: '',
        match: {
          path: pathSection,
          url: pathSection,
          isExact: true
        },
        title: ''
      };
      matches.push(breadcrumbMatch);
    }

    return pathSection;
  });
  return matches;
};
export var urlAnalyse = function urlAnalyse(routes) {
  return function (Component) {
    return withRouter(function (props) {
      return React.createElement(Component, Object.assign({}, props, {
        breadcrumbs: getUrlStructure({
          pathname: props.location.pathname,
          routes: routes
        })
      }));
    });
  };
};